"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _UserChange = _interopRequireDefault(require("@rsuite/icon-font/lib/people/UserChange"));

// Generated by script, don't edit it please.
var UserChange = (0, _createSvgIcon["default"])({
  as: _UserChange["default"],
  ariaLabel: 'user change',
  category: 'people',
  displayName: 'UserChange'
});
var _default = UserChange;
exports["default"] = _default;
module.exports = exports.default;